/**
 * Generated by orval 🍺
 * Do not edit manually.
 * api API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { ChangePasswordRequest } from "../models/changePasswordRequest";

import type { CurrentUserDetails } from "../models/currentUserDetails";

import type { ExecuteWorkflowNodeRequest } from "../models/executeWorkflowNodeRequest";

import type { RegisterBiometricRequest } from "../models/registerBiometricRequest";

import type { ResetPasswordRequest } from "../models/resetPasswordRequest";

import type { SessionHandshakeBody } from "../models/sessionHandshakeBody";

import type { UpdateLocaleParams } from "../models/updateLocaleParams";

import type { UpdateUserAttributesBody } from "../models/updateUserAttributesBody";

import type { User } from "../models/user";

import type { UserBiometricDetailsResponse } from "../models/userBiometricDetailsResponse";

import type { UserGroupSubscriptionRequest } from "../models/userGroupSubscriptionRequest";

import type { UserMutationResponse } from "../models/userMutationResponse";

import type { UserUpdateRequest } from "../models/userUpdateRequest";

import { executeFetch } from "../../utils/fetch/fetch";
import type { ErrorType } from "../../utils/fetch/fetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Create Or Update User
 */
export const createOrUpdateUser = (
  user: User,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<UserMutationResponse>(
    {
      url: `/api/user`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: user,
      signal,
    },
    options,
  );
};

export const getCreateOrUpdateUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrUpdateUser>>,
    TError,
    { data: User },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrUpdateUser>>,
  TError,
  { data: User },
  TContext
> => {
  const mutationKey = ["createOrUpdateUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrUpdateUser>>,
    { data: User }
  > = (props, context) => {
    const { data } = props ?? {};

    return createOrUpdateUser(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOrUpdateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrUpdateUser>>
>;
export type CreateOrUpdateUserMutationBody = User;
export type CreateOrUpdateUserMutationError = ErrorType<unknown>;

/**
 * @summary Create Or Update User
 */
export const useCreateOrUpdateUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOrUpdateUser>>,
      TError,
      { data: User },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createOrUpdateUser>>,
  TError,
  { data: User },
  TContext
> => {
  const mutationOptions = getCreateOrUpdateUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Add Users To Groups
 */
export const addUsersToGroups = (
  userGroupSubscriptionRequest: UserGroupSubscriptionRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<void>(
    {
      url: `/api/user/add-users-to-groups`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: userGroupSubscriptionRequest,
      signal,
    },
    options,
  );
};

export const getAddUsersToGroupsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addUsersToGroups>>,
    TError,
    { data: UserGroupSubscriptionRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addUsersToGroups>>,
  TError,
  { data: UserGroupSubscriptionRequest },
  TContext
> => {
  const mutationKey = ["addUsersToGroups"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addUsersToGroups>>,
    { data: UserGroupSubscriptionRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return addUsersToGroups(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type AddUsersToGroupsMutationResult = NonNullable<
  Awaited<ReturnType<typeof addUsersToGroups>>
>;
export type AddUsersToGroupsMutationBody = UserGroupSubscriptionRequest;
export type AddUsersToGroupsMutationError = ErrorType<unknown>;

/**
 * @summary Add Users To Groups
 */
export const useAddUsersToGroups = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addUsersToGroups>>,
      TError,
      { data: UserGroupSubscriptionRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addUsersToGroups>>,
  TError,
  { data: UserGroupSubscriptionRequest },
  TContext
> => {
  const mutationOptions = getAddUsersToGroupsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Change Password
 */
export const changePassword = (
  changePasswordRequest: ChangePasswordRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    {
      url: `/api/user/change-password`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: changePasswordRequest,
      signal,
    },
    options,
  );
};

export const getChangePasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePassword>>,
    TError,
    { data: ChangePasswordRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changePassword>>,
  TError,
  { data: ChangePasswordRequest },
  TContext
> => {
  const mutationKey = ["changePassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changePassword>>,
    { data: ChangePasswordRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return changePassword(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof changePassword>>
>;
export type ChangePasswordMutationBody = ChangePasswordRequest;
export type ChangePasswordMutationError = ErrorType<unknown>;

/**
 * @summary Change Password
 */
export const useChangePassword = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changePassword>>,
      TError,
      { data: ChangePasswordRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof changePassword>>,
  TError,
  { data: ChangePasswordRequest },
  TContext
> => {
  const mutationOptions = getChangePasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @deprecated
 * @summary Create Or Update User Details
 */
export const createOrUpdateUserDetails = (
  userUpdateRequest: UserUpdateRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<UserMutationResponse>(
    {
      url: `/api/user/create-or-update`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: userUpdateRequest,
      signal,
    },
    options,
  );
};

export const getCreateOrUpdateUserDetailsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrUpdateUserDetails>>,
    TError,
    { data: UserUpdateRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrUpdateUserDetails>>,
  TError,
  { data: UserUpdateRequest },
  TContext
> => {
  const mutationKey = ["createOrUpdateUserDetails"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrUpdateUserDetails>>,
    { data: UserUpdateRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return createOrUpdateUserDetails(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOrUpdateUserDetailsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrUpdateUserDetails>>
>;
export type CreateOrUpdateUserDetailsMutationBody = UserUpdateRequest;
export type CreateOrUpdateUserDetailsMutationError = ErrorType<unknown>;

/**
 * @deprecated
 * @summary Create Or Update User Details
 */
export const useCreateOrUpdateUserDetails = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOrUpdateUserDetails>>,
      TError,
      { data: UserUpdateRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createOrUpdateUserDetails>>,
  TError,
  { data: UserUpdateRequest },
  TContext
> => {
  const mutationOptions = getCreateOrUpdateUserDetailsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete User
 */
export const deleteUser = (
  userId: number,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<void>(
    {
      url: `/api/user/delete/${encodeURIComponent(String(userId))}`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getDeleteUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUser>>,
    TError,
    { userId: number },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  { userId: number },
  TContext
> => {
  const mutationKey = ["deleteUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUser>>,
    { userId: number }
  > = (props, context) => {
    const { userId } = props ?? {};

    return deleteUser(userId, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUser>>
>;

export type DeleteUserMutationError = ErrorType<unknown>;

/**
 * @summary Delete User
 */
export const useDeleteUser = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteUser>>,
      TError,
      { userId: number },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  { userId: number },
  TContext
> => {
  const mutationOptions = getDeleteUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Deregister Biometric
 */
export const deregisterBiometric = (
  deviceIdentifierId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    {
      url: `/api/user/deregister-biometric/${encodeURIComponent(String(deviceIdentifierId))}`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getDeregisterBiometricMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deregisterBiometric>>,
    TError,
    { deviceIdentifierId: string },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deregisterBiometric>>,
  TError,
  { deviceIdentifierId: string },
  TContext
> => {
  const mutationKey = ["deregisterBiometric"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deregisterBiometric>>,
    { deviceIdentifierId: string }
  > = (props, context) => {
    const { deviceIdentifierId } = props ?? {};

    return deregisterBiometric(deviceIdentifierId, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type DeregisterBiometricMutationResult = NonNullable<
  Awaited<ReturnType<typeof deregisterBiometric>>
>;

export type DeregisterBiometricMutationError = ErrorType<unknown>;

/**
 * @summary Deregister Biometric
 */
export const useDeregisterBiometric = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deregisterBiometric>>,
      TError,
      { deviceIdentifierId: string },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deregisterBiometric>>,
  TError,
  { deviceIdentifierId: string },
  TContext
> => {
  const mutationOptions = getDeregisterBiometricMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Biometric Details
 */
export const getBiometricDetails = (
  deviceIdentifierId: string,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<UserBiometricDetailsResponse>(
    {
      url: `/api/user/is-biometric-registered/${encodeURIComponent(String(deviceIdentifierId))}`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getGetBiometricDetailsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getBiometricDetails>>,
    TError,
    { deviceIdentifierId: string },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getBiometricDetails>>,
  TError,
  { deviceIdentifierId: string },
  TContext
> => {
  const mutationKey = ["getBiometricDetails"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getBiometricDetails>>,
    { deviceIdentifierId: string }
  > = (props, context) => {
    const { deviceIdentifierId } = props ?? {};

    return getBiometricDetails(deviceIdentifierId, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type GetBiometricDetailsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getBiometricDetails>>
>;

export type GetBiometricDetailsMutationError = ErrorType<unknown>;

/**
 * @summary Get Biometric Details
 */
export const useGetBiometricDetails = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getBiometricDetails>>,
      TError,
      { deviceIdentifierId: string },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getBiometricDetails>>,
  TError,
  { deviceIdentifierId: string },
  TContext
> => {
  const mutationOptions = getGetBiometricDetailsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Is Logged In
 */
export const isLoggedIn = (
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<User>(
    { url: `/api/user/logged-in`, method: "GET", signal },
    options,
  );
};

export const getIsLoggedInQueryKey = () => {
  return [`/api/user/logged-in`] as const;
};

export const getIsLoggedInQueryOptions = <
  TData = Awaited<ReturnType<typeof isLoggedIn>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof isLoggedIn>>, TError, TData>
  >;
  request?: SecondParameter<typeof executeFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIsLoggedInQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof isLoggedIn>>> = ({
    signal,
    meta,
  }) => isLoggedIn({ ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof isLoggedIn>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type IsLoggedInQueryResult = NonNullable<
  Awaited<ReturnType<typeof isLoggedIn>>
>;
export type IsLoggedInQueryError = ErrorType<unknown>;

export function useIsLoggedIn<
  TData = Awaited<ReturnType<typeof isLoggedIn>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof isLoggedIn>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof isLoggedIn>>,
          TError,
          Awaited<ReturnType<typeof isLoggedIn>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useIsLoggedIn<
  TData = Awaited<ReturnType<typeof isLoggedIn>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof isLoggedIn>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof isLoggedIn>>,
          TError,
          Awaited<ReturnType<typeof isLoggedIn>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useIsLoggedIn<
  TData = Awaited<ReturnType<typeof isLoggedIn>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof isLoggedIn>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Is Logged In
 */

export function useIsLoggedIn<
  TData = Awaited<ReturnType<typeof isLoggedIn>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof isLoggedIn>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getIsLoggedInQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Is Logged In
 */
export const prefetchIsLoggedIn = async <
  TData = Awaited<ReturnType<typeof isLoggedIn>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof isLoggedIn>>, TError, TData>
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getIsLoggedInQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Logged In User
 */
export const getLoggedInUser = (
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<User>(
    { url: `/api/user/logged-in-user`, method: "GET", signal },
    options,
  );
};

export const getGetLoggedInUserQueryKey = () => {
  return [`/api/user/logged-in-user`] as const;
};

export const getGetLoggedInUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getLoggedInUser>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLoggedInUser>>, TError, TData>
  >;
  request?: SecondParameter<typeof executeFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLoggedInUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoggedInUser>>> = ({
    signal,
    meta,
  }) => getLoggedInUser({ ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLoggedInUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLoggedInUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLoggedInUser>>
>;
export type GetLoggedInUserQueryError = ErrorType<unknown>;

export function useGetLoggedInUser<
  TData = Awaited<ReturnType<typeof getLoggedInUser>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLoggedInUser>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoggedInUser>>,
          TError,
          Awaited<ReturnType<typeof getLoggedInUser>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLoggedInUser<
  TData = Awaited<ReturnType<typeof getLoggedInUser>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLoggedInUser>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoggedInUser>>,
          TError,
          Awaited<ReturnType<typeof getLoggedInUser>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLoggedInUser<
  TData = Awaited<ReturnType<typeof getLoggedInUser>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLoggedInUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Logged In User
 */

export function useGetLoggedInUser<
  TData = Awaited<ReturnType<typeof getLoggedInUser>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLoggedInUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetLoggedInUserQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Logged In User
 */
export const prefetchGetLoggedInUser = async <
  TData = Awaited<ReturnType<typeof getLoggedInUser>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLoggedInUser>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetLoggedInUserQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Logged In User Details
 */
export const getLoggedInUserDetails = (
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<CurrentUserDetails>(
    { url: `/api/user/logged-in-user-details`, method: "GET", signal },
    options,
  );
};

export const getGetLoggedInUserDetailsQueryKey = () => {
  return [`/api/user/logged-in-user-details`] as const;
};

export const getGetLoggedInUserDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getLoggedInUserDetails>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLoggedInUserDetails>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof executeFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLoggedInUserDetailsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLoggedInUserDetails>>
  > = ({ signal, meta }) =>
    getLoggedInUserDetails({ ...requestOptions, meta }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLoggedInUserDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLoggedInUserDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLoggedInUserDetails>>
>;
export type GetLoggedInUserDetailsQueryError = ErrorType<unknown>;

export function useGetLoggedInUserDetails<
  TData = Awaited<ReturnType<typeof getLoggedInUserDetails>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLoggedInUserDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoggedInUserDetails>>,
          TError,
          Awaited<ReturnType<typeof getLoggedInUserDetails>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLoggedInUserDetails<
  TData = Awaited<ReturnType<typeof getLoggedInUserDetails>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLoggedInUserDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoggedInUserDetails>>,
          TError,
          Awaited<ReturnType<typeof getLoggedInUserDetails>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLoggedInUserDetails<
  TData = Awaited<ReturnType<typeof getLoggedInUserDetails>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLoggedInUserDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Logged In User Details
 */

export function useGetLoggedInUserDetails<
  TData = Awaited<ReturnType<typeof getLoggedInUserDetails>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLoggedInUserDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetLoggedInUserDetailsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Logged In User Details
 */
export const prefetchGetLoggedInUserDetails = async <
  TData = Awaited<ReturnType<typeof getLoggedInUserDetails>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLoggedInUserDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetLoggedInUserDetailsQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Register Biometric
 */
export const registerBiometric = (
  registerBiometricRequest: RegisterBiometricRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<UserBiometricDetailsResponse>(
    {
      url: `/api/user/register-biometric`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: registerBiometricRequest,
      signal,
    },
    options,
  );
};

export const getRegisterBiometricMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerBiometric>>,
    TError,
    { data: RegisterBiometricRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerBiometric>>,
  TError,
  { data: RegisterBiometricRequest },
  TContext
> => {
  const mutationKey = ["registerBiometric"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerBiometric>>,
    { data: RegisterBiometricRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return registerBiometric(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterBiometricMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerBiometric>>
>;
export type RegisterBiometricMutationBody = RegisterBiometricRequest;
export type RegisterBiometricMutationError = ErrorType<unknown>;

/**
 * @summary Register Biometric
 */
export const useRegisterBiometric = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof registerBiometric>>,
      TError,
      { data: RegisterBiometricRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof registerBiometric>>,
  TError,
  { data: RegisterBiometricRequest },
  TContext
> => {
  const mutationOptions = getRegisterBiometricMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Remove Users From Groups
 */
export const removeUsersFromGroups = (
  userGroupSubscriptionRequest: UserGroupSubscriptionRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<void>(
    {
      url: `/api/user/remove-users-from-groups`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: userGroupSubscriptionRequest,
      signal,
    },
    options,
  );
};

export const getRemoveUsersFromGroupsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeUsersFromGroups>>,
    TError,
    { data: UserGroupSubscriptionRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeUsersFromGroups>>,
  TError,
  { data: UserGroupSubscriptionRequest },
  TContext
> => {
  const mutationKey = ["removeUsersFromGroups"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeUsersFromGroups>>,
    { data: UserGroupSubscriptionRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return removeUsersFromGroups(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveUsersFromGroupsMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeUsersFromGroups>>
>;
export type RemoveUsersFromGroupsMutationBody = UserGroupSubscriptionRequest;
export type RemoveUsersFromGroupsMutationError = ErrorType<unknown>;

/**
 * @summary Remove Users From Groups
 */
export const useRemoveUsersFromGroups = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeUsersFromGroups>>,
      TError,
      { data: UserGroupSubscriptionRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeUsersFromGroups>>,
  TError,
  { data: UserGroupSubscriptionRequest },
  TContext
> => {
  const mutationOptions = getRemoveUsersFromGroupsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Reset Password With Body
 */
export const resetPasswordWithBody = (
  resetPasswordRequest: ResetPasswordRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    {
      url: `/api/user/reset-password`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: resetPasswordRequest,
      signal,
    },
    options,
  );
};

export const getResetPasswordWithBodyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetPasswordWithBody>>,
    TError,
    { data: ResetPasswordRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetPasswordWithBody>>,
  TError,
  { data: ResetPasswordRequest },
  TContext
> => {
  const mutationKey = ["resetPasswordWithBody"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetPasswordWithBody>>,
    { data: ResetPasswordRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return resetPasswordWithBody(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetPasswordWithBodyMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetPasswordWithBody>>
>;
export type ResetPasswordWithBodyMutationBody = ResetPasswordRequest;
export type ResetPasswordWithBodyMutationError = ErrorType<unknown>;

/**
 * @summary Reset Password With Body
 */
export const useResetPasswordWithBody = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resetPasswordWithBody>>,
      TError,
      { data: ResetPasswordRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof resetPasswordWithBody>>,
  TError,
  { data: ResetPasswordRequest },
  TContext
> => {
  const mutationOptions = getResetPasswordWithBodyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Session Handshake
 */
export const sessionHandshake = (
  sessionHandshakeBody: SessionHandshakeBody,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<void>(
    {
      url: `/api/user/session-handshake`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: sessionHandshakeBody,
      signal,
    },
    options,
  );
};

export const getSessionHandshakeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sessionHandshake>>,
    TError,
    { data: SessionHandshakeBody },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sessionHandshake>>,
  TError,
  { data: SessionHandshakeBody },
  TContext
> => {
  const mutationKey = ["sessionHandshake"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sessionHandshake>>,
    { data: SessionHandshakeBody }
  > = (props, context) => {
    const { data } = props ?? {};

    return sessionHandshake(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type SessionHandshakeMutationResult = NonNullable<
  Awaited<ReturnType<typeof sessionHandshake>>
>;
export type SessionHandshakeMutationBody = SessionHandshakeBody;
export type SessionHandshakeMutationError = ErrorType<unknown>;

/**
 * @summary Session Handshake
 */
export const useSessionHandshake = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sessionHandshake>>,
      TError,
      { data: SessionHandshakeBody },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sessionHandshake>>,
  TError,
  { data: SessionHandshakeBody },
  TContext
> => {
  const mutationOptions = getSessionHandshakeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Locale
 */
export const updateLocale = (
  params?: UpdateLocaleParams,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    { url: `/api/user/update-locale`, method: "POST", params, signal },
    options,
  );
};

export const getUpdateLocaleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLocale>>,
    TError,
    { params?: UpdateLocaleParams },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLocale>>,
  TError,
  { params?: UpdateLocaleParams },
  TContext
> => {
  const mutationKey = ["updateLocale"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLocale>>,
    { params?: UpdateLocaleParams }
  > = (props, context) => {
    const { params } = props ?? {};

    return updateLocale(params, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLocaleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLocale>>
>;

export type UpdateLocaleMutationError = ErrorType<unknown>;

/**
 * @summary Update Locale
 */
export const useUpdateLocale = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateLocale>>,
      TError,
      { params?: UpdateLocaleParams },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateLocale>>,
  TError,
  { params?: UpdateLocaleParams },
  TContext
> => {
  const mutationOptions = getUpdateLocaleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Password
 */
export const updatePassword = (
  executeWorkflowNodeRequest: ExecuteWorkflowNodeRequest,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    {
      url: `/api/user/update-password`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: executeWorkflowNodeRequest,
      signal,
    },
    options,
  );
};

export const getUpdatePasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePassword>>,
    TError,
    { data: ExecuteWorkflowNodeRequest },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePassword>>,
  TError,
  { data: ExecuteWorkflowNodeRequest },
  TContext
> => {
  const mutationKey = ["updatePassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePassword>>,
    { data: ExecuteWorkflowNodeRequest }
  > = (props, context) => {
    const { data } = props ?? {};

    return updatePassword(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePassword>>
>;
export type UpdatePasswordMutationBody = ExecuteWorkflowNodeRequest;
export type UpdatePasswordMutationError = ErrorType<unknown>;

/**
 * @summary Update Password
 */
export const useUpdatePassword = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePassword>>,
      TError,
      { data: ExecuteWorkflowNodeRequest },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePassword>>,
  TError,
  { data: ExecuteWorkflowNodeRequest },
  TContext
> => {
  const mutationOptions = getUpdatePasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update User Attributes
 */
export const updateUserAttributes = (
  updateUserAttributesBody: UpdateUserAttributesBody,
  options?: SecondParameter<typeof executeFetch>,
  signal?: AbortSignal,
) => {
  return executeFetch<unknown>(
    {
      url: `/api/user/update-user-attributes`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: updateUserAttributesBody,
      signal,
    },
    options,
  );
};

export const getUpdateUserAttributesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserAttributes>>,
    TError,
    { data: UpdateUserAttributesBody },
    TContext
  >;
  request?: SecondParameter<typeof executeFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserAttributes>>,
  TError,
  { data: UpdateUserAttributesBody },
  TContext
> => {
  const mutationKey = ["updateUserAttributes"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserAttributes>>,
    { data: UpdateUserAttributesBody }
  > = (props, context) => {
    const { data } = props ?? {};

    return updateUserAttributes(data, {
      ...requestOptions,
      meta: { ...context.meta, ...requestOptions?.meta },
    });
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserAttributesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUserAttributes>>
>;
export type UpdateUserAttributesMutationBody = UpdateUserAttributesBody;
export type UpdateUserAttributesMutationError = ErrorType<unknown>;

/**
 * @summary Update User Attributes
 */
export const useUpdateUserAttributes = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateUserAttributes>>,
      TError,
      { data: UpdateUserAttributesBody },
      TContext
    >;
    request?: SecondParameter<typeof executeFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateUserAttributes>>,
  TError,
  { data: UpdateUserAttributesBody },
  TContext
> => {
  const mutationOptions = getUpdateUserAttributesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
